<template>
  <section class="container-fluid">
    <b-modal
      size="md"
      hide-footer
      no-close-on-backdrop
      @hidden="onReset"
      ref="projectModal"
      static
    >
      <template v-slot:modal-header="{ close }">
        <h5 class="modal-title">
          {{ isEdit ? 'Edit project' : 'Create project' }}
        </h5>
        <button
          type="button"
          aria-label="Close"
          class="close"
          @click.prevent="close"
        >
          <span class="material-icons">
            close
          </span>
        </button>
      </template>

      <preloader v-if="isDataPageLoading"/>
      <b-form class="form-generator row" @submit.prevent="submit" @reset="onReset">
        <b-form-group class="col-6">
          <label>Project manager*</label>
          <multiselect
            v-model="form.project_manager"
            :options="getProjectManagersList"
            value-field="id"
            placeholder="Project Manager"
            label="name"
            :showLabels="false"
          />
        </b-form-group>
        <b-form-group class="col-6">
          <label>Account manager</label>
          <multiselect
            v-model="form.account_manager"
            :options="getAccountManagersList"
            value-field="id"
            placeholder="Account Manager"
            label="name"
            :showLabels="false"
          />
        </b-form-group>

        <b-form-group class="col-6">
          <label>Business developer*</label>
          <multiselect
            v-model="form.business_developer"
            :options="getBusinessDevelopersList"
            value-field="id"
            placeholder="Business Developer"
            label="name"
            :showLabels="false"
          />
        </b-form-group>

        <b-form-group class="col-6">
          <label>Pre-sales manager</label>
          <multiselect
            v-model="form.pre_sales_manager"
            :options="getBusinessDevelopersList"
            value-field="id"
            placeholder="Pre-sales manager"
            label="name"
            :showLabels="false"
          />
        </b-form-group>

        <b-form-group class="col-12">
          <label>Sales channel*</label>
          <multiselect
            v-model="form.sales_channel"
            :options="salesChannels"
            value-field="id"
            placeholder="Sales channel"
            label="name"
            :showLabels="false"
            required
          />
        </b-form-group>

        <b-form-group class="col-12">
          <b-form-checkbox
            id="is_custom_project"
            v-model="form.is_custom_project"
            name="is_custom_project"
            value="1">
            Custom project (without jira board)
          </b-form-checkbox>
        </b-form-group>

            <b-form-group v-if="!form.is_custom_project" class="col-12">
              <label>Jira project*</label>

          <multiselect
            v-if="!form.is_custom_project"
            v-model="form.project"
            :options="getJiraProjectsList"
            required
            placeholder="Jira Project"
            label="name"
            :showLabels="false"
          />
        </b-form-group>

        <b-form-group v-if="form.is_custom_project" class="col-12">
          <label>Create custom project</label>
          <b-form-input
            class="mb-3"
            v-model="form.custom_project_key"
            maxlength="4"
            placeholder="Project key (Example: ART)"
          />
          <b-form-input
            class="mb-3"
            v-model="form.custom_project_name"
            maxlength="50"
            placeholder="Project name (Example: Artoui)"
          />

              <b-form-input
                v-model="form.custom_project_task_for_logging_time"
                maxlength="100"
                placeholder="Jira task KEY (Example: OUT-1)"/>

        </b-form-group>
        <b-form-group class="col-12">
          <div class="row">
            <div class="col-6">
              <label>Project types</label>
              <multiselect
                v-model="form.project_type"
                :options="projectTypesOptions"
                required
                placeholder="Select type"
                :showLabels="false"
              />
            </div>
            <div class="col-6">
              <label>Project status</label>
              <multiselect
                v-model="form.status"
                :options="projectStatuses"
                required
                placeholder="Select status"
                :showLabels="false"
              />
            </div>
          </div>
        </b-form-group>
        <b-form-group class="col-12">
          <label>Agreement</label>
          <b-form-input
            class="mb-3"
            v-model="form.agreement_url"
            maxlength="2000"
            placeholder="Agreement url (Example: https://domain.org/agreements/12-215134)"
          />
          <b-form-input
            class="mb-3"
            v-model="form.agreement_number"
            maxlength="255"
            placeholder="Agreement number (Example: 12/215134)"
          />
        </b-form-group>
        <b-form-group class="col-12">
          <div class="row">
            <div class="col-6">
              <label>Project priority*</label>
              <multiselect
                v-model="form.priority"
                :options="priorities"
                required
                placeholder="Priority"
                class="project-select"
                label="name"
                :showLabels="false"
              />
            </div>
<!--            <div class="col-4">
              <label>Budget risks %*</label>
              <b-form-input
                v-model="form.budget_risks"
                maxlength="10"
                placeholder="Budget risks %"/>
            </div>-->
            <div class="col-6">
              <label>Project color*</label>
              <multiselect
                v-model="form.color"
                :options="config.colors"
                placeholder="Color"
                class="project-select multiselect-color"
                label="name"
                :showLabels="false"
                required
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <div
                    class="multiselect-color__selected-box"
                    :style="{'background-color': option.hex}"
                  >
                  </div>
                </template>
                <template slot="option" slot-scope="props">
                  <div class="option__desc">
                    <div class="multiselect-color__box" :style="{'background-color': props.option.hex}"></div>
                    {{ props.option.name }}
                  </div>
                </template>
              </multiselect>
            </div>
          </div>
        </b-form-group>
        <b-form-group class="col-12 form-generator__controls">
          <div class="form-generator-buttons">
            <b-button type="reset" variant="outline" class="button mr-2" v-if="!isEdit">
              Reset
            </b-button>
            <b-button type="submit" variant="primary" class="button" :disabled="checkFormForEmptyFields">
              Save
            </b-button>
          </div>
        </b-form-group>
      </b-form>
    </b-modal>
    <b-row>
      <b-col class="px-0" style="position: relative">
        <div class="title-container">
          <h3 class="title">
            Project List
            <div
              class="spinner-border spinner-theme_default"
              role="status"
              v-if="isDataPageLoading"
            >
                <span class="sr-only">
                  Loading...
                </span>
            </div>
          </h3>
          <div class="title-container__controls">
            <b-button
              class="button title-container__controls-item"
              :variant="isShowFilter ? 'secondary' : 'info'"
              @click="toggleShowFilter"
            >
                <span class="material-icons icon-image-preview">
                  tune
                </span>
              Filter
            </b-button>
            <b-button
              v-if="$can('create-projects')"
              variant="success"
              class="button"
              @click="create"
              :disabled="isDataPageLoading"
            >
              Create
            </b-button>
          </div>
        </div>

        <Filters
          ref="filters"
          v-show="isShowFilter"
          textButtonSubmit="Filter"
          :data="filters"
          :isLoading="isDataPageLoading"
          @submit="filterProject"
        />
        <TableForPage
          ref="table"
          style="margin-bottom: 0;"
          v-if="projects.length"
          :tableData="projects"
          :fields="fields"
          :slots="tableSlots"
          :isEdit="$can('update_all-projects')"
          :isRemove="$can('create-projects')"
          @edit="edit"
          @remove="remove"
        >
          <template v-slot:name="data">
            <a
              :href="`https://giraffesoftware.atlassian.net/browse/${getProjectDashboardKey(data.item)}`"
              target="_blank"
            >
              {{ data.item.name }}
            </a>
          </template>
          <template v-slot:color="slotProps">
            <div class="project-color">
              <span
                :style="{ backgroundColor: slotProps.item.color || '#4080BF' }"
              >
              </span>
            </div>
          </template>
          <template v-slot:project_status.name="slotProps">
            <span class="project-status" :class="slotProps.item.project_status.name">
              {{ slotProps.item.project_status.name }}
            </span>
          </template>
          <template v-slot:priority="slotProps" >
            {{findPriorityById(slotProps.item.priority)}}
          </template>
        </TableForPage>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'
import Preloader from '@/components/Preloader.vue'
import TableForPage from '@tables/TableForPage'
import Filters from '@components/Filter/Filter'
import { deepFindObjectValueByPath } from '../functions/deepFindObjectValueByPath'

export default {
  name: 'Projects',
  data () {
    return {
      isShowFilter: true,
      filters: {
        'projects': {
          type: 'multiselect',
          name: 'projects',
          label: 'Select projects',
          valueField: 'name',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-2',
          pathToObjectValue: 'name'
        },
        'project_manager': {
          type: 'multiselect',
          name: 'project_manager',
          label: 'Select Project manager',
          valueField: 'name',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3',
          pathToObjectValue: 'project_manager.name'
        },
        'account_manager': {
          type: 'multiselect',
          name: 'account_manager',
          label: 'Select Account manager',
          valueField: 'name',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-2',
          pathToObjectValue: 'account_manager.name'
        },
        'business_developer': {
          type: 'multiselect',
          name: 'business_developer',
          label: 'Select Business developer',
          valueField: 'name',
          selectLabel: 'name',
          options: [],
          value: '',
          class: 'col-md-3',
          pathToObjectValue: 'business_developer.name'
        },
        'project_status': {
          type: 'multiselect',
          name: 'project_status',
          label: 'Select Status',
          selectLabel: null,
          options: [],
          value: '',
          class: 'col-md-2',
          pathToObjectValue: 'project_status.name'
        }
      },
      config: {
        colors: [
          { name: 'Red', hex: '#DA4F57' },
          { name: 'Pink', hex: '#D81B60' },
          { name: 'Purple', hex: '#AB47BC' },
          { name: 'Blue', hex: '#477DD0' },
          { name: 'Cyan', hex: '#0097A7' },
          { name: 'Green', hex: '#43A047' },
          { name: 'Orange', hex: '#EF6C00' },
          { name: 'Brown', hex: '#8D6E63' },
          { name: 'Amber', hex: '#FF8F00' },
          { name: 'Light Green', hex: '#9CCC65' }
        ]
      },
      transProps: {
        // Transition name
        name: 'flip-list'
      },
      isDataPageLoading: false,

      fields: [
        {
          label: 'Color',
          key: 'color',
          sortable: false
        },
        {
          label: 'Priority',
          key: 'priority',
          sortable: false
        },
        {
          label: 'Name',
          key: 'name',
          sortable: true
        },
        {
          label: 'Log task',
          key: 'task_for_logging_time',
          sortable: false,
          formatter: value => {
            return value ? value.join(',') : ''
          }
        },
        {
          label: 'PM',
          key: 'project_manager.name',
          sortable: true
        },
        {
          label: 'AM',
          key: 'account_manager.name',
          sortable: true
        },
        {
          label: 'BD',
          key: 'business_developer.name',
          sortable: true
        },
        {
          label: 'Status',
          key: 'project_status.name',
          sortable: true
        },
        {
          key: 'actions',
          label: 'Actions',
          class: 'column_action'
        }
      ],
      form: {
        id: null,
        project_manager: '',
        account_manager: '',
        business_developer: '',
        pre_sales_manager: '',
        is_custom_project: false,
        sales_channel: null,
        custom_project_key: '',
        custom_project_name: '',
        custom_project_task_for_logging_time: '',
        status: 'development',
        project: '',
        priority: {
          id: 3,
          name: 'Medium'
        },
        budget_risks: '0',
        project_type: 'external',
        agreement_url: '',
        agreement_number: '',
        color: { name: 'Red', hex: '#DA4F57' }
      },
      jiraProjects: [],
      projects: [],
      perPage: 15,
      projectTypesOptions: [
        'internal',
        'external'
      ],
      tableSlots: {
        name: {
          name: 'name'
        },
        color: {
          name: 'color'
        },
        priority: {
          name: 'priority'
        },
        'project_status.name': {
          name: 'project_status.name'
        }
      }
    }
  },
  components: {
    Preloader,
    TableForPage,
    Filters
  },
  computed: {
    ...mapGetters({
      priorities: 'getPriorities',
      projectStatuses: 'getProjectStatuses',
      salesChannels: 'finances/getSalesChannels'
    }),
    getProjects () {
      return [...this.$store.getters['projects/getProjects']]
        .sort((project1, project2) => project1.created_at < project2.created_at ? 1 : -1)
    },
    getJiraProjectsList () {
      if (!this.$store.getters['projects/getJiraProjects'].length) return []
      return [...this.$store.getters['projects/getJiraProjects']].sort((project1, project2) => project1.name < project2.name ? -1 : 1)
    },
    getBusinessDevelopersList () {
      if (!this.$store.getters['businessDevelopers/getBusinessDevelopers'].length) return []
      return [...this.$store.getters['businessDevelopers/getBusinessDevelopers']].sort((user1, user2) => user1.name < user2.name ? -1 : 1)
    },
    getProjectManagersList () {
      if (!this.$store.getters['users/getProjectManagers'].length) return []
      return [...this.$store.getters['users/getProjectManagers']].sort((user1, user2) => user1.name < user2.name ? -1 : 1)
    },
    getAccountManagersList () {
      if (!this.$store.getters['users/getAccountManagers'].length) return []
      return [...this.$store.getters['users/getAccountManagers']].sort((user1, user2) => user1.name < user2.name ? -1 : 1)
    },
    isEdit () {
      return this.form.id
    },
    checkFormForEmptyFields () {
      /* eslint-disable camelcase */
      /* eslint-disable no-mixed-operators */
      const {
        project_manager,
        account_manager,
        project,
        priority,
        budget_risks,
        custom_project_key,
        custom_project_name,
        custom_project_task_for_logging_time,
        is_custom_project,
        status,
        project_type,
        business_developer,
        agreement_url,
        agreement_number
      } = this.form

      if (!business_developer || !project_manager && !account_manager || !project && !is_custom_project || !priority || !status || !budget_risks || !project_type) {
        return true
      }

      if (is_custom_project && !custom_project_name || is_custom_project && !custom_project_key || is_custom_project && !custom_project_task_for_logging_time) {
        return true
      }

      if ((agreement_url && !agreement_number) || (agreement_number && !agreement_url)) {
        return true
      }

      return false
    },
    formDefault () {
      const defaultSalesChannel = this.salesChannels.find(item => item.is_default)
      return {
        id: null,
        project_manager: '',
        account_manager: '',
        business_developer: '',
        pre_sales_manager: '',
        is_custom_project: false,
        custom_project_key: '',
        custom_project_name: '',
        custom_project_task_for_logging_time: '',
        sales_channel: defaultSalesChannel,
        status: '',
        project_type: '',
        project: '',
        priority: '',
        budget_risks: '0',
        color: {
          hex: '#4080BF'
        },
        agreement_url: '',
        agreement_number: ''
      }
    }
  },
  created () {
    this._toggleDataPageLoading(async () => {
      await this.fetchAllData()
    })
  },
  methods: {
    isItemEqualFilter (filters, filterKey, item) {
      const keyForFilterItem = filters[filterKey]['valueField']
      return filters[filterKey]['value'].some(filterItem => (filterItem[keyForFilterItem] || filterItem) === item)
    },
    filterProject (selectedFilters) {
      this.projects = this.getProjects.filter(item => {
        let isAllEqual = true

        for (const key in selectedFilters) {
          const isItemEqual = this.isItemEqualFilter(
            selectedFilters,
            key,
            deepFindObjectValueByPath(item, selectedFilters[key]['pathToObjectValue'])
          )

          if (!isItemEqual) {
            isAllEqual = false
            break
          }
        }
        return isAllEqual
      })

      this.resetPagination()
    },
    resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    fetchAllData () {
      Promise.all([
        this.fetchProjects(),
        this.$api.users.getProjectManagers(),
        this.$api.users.getAccountManagers(),
        this.$api.businessDevelopers.getBusinessDevelopers(),
        this.$api.projects.getJiraProjects(),
        this.$api.finances.getSalesChannels()
      ])
        .then(() => {
          this.setAllOptionsFilter()
        })
    },
    setAllOptionsFilter () {
      this.filters.project_manager.options = this.getProjectManagersList
      this.filters.account_manager.options = this.getAccountManagersList
      this.filters.business_developer.options = this.getBusinessDevelopersList
      this.filters.project_status.options = this.projectStatuses
      this.filters.project_status.value = ['predevelopment', 'development']
      this.filters.projects.options = this.getProjects
      this.filterProject({ project_status: this.filters.project_status })
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    showModal () {
      this.$refs['projectModal'].show()
    },
    hideModal () {
      this.$refs['projectModal'].hide()
      this.onReset()
    },
    create () {
      this.form.sales_channel = this.salesChannels.find(item => item.is_default)
      this.showModal()
    },
    edit (project) {
      this.form = { ...project,
        priority: this.findPriorityById(project.priority, true),
        budget_risks: project.budget_risks ? project.budget_risks : '0',
        project: project.is_custom_project ? '' : this.findProjectBId(project.id, true),
        custom_project_key: project.is_custom_project ? project.key : '',
        custom_project_name: project.is_custom_project ? project.name : '',
        custom_project_task_for_logging_time: project.is_custom_project ? project.task_for_logging_time.join(',') : '',
        agreement_url: project.agreement_url ? project.agreement_url : '',
        agreement_number: project.agreement_number ? project.agreement_number : '',
        color: { hex: project.color },
        status: project.project_status.name,
        project_type: project.project_type.name,
        sales_channel: project.sales_channel,
        pre_sales_manager: project.pre_sales_manager
      }
      this.showModal()
    },
    prepareFormDataForRequest () {
      /* eslint-disable camelcase */
      const {
        color,
        priority,
        budget_risks,
        project,
        project_manager,
        account_manager,
        business_developer,
        is_custom_project,
        custom_project_key,
        custom_project_name,
        custom_project_task_for_logging_time,
        status,
        project_type,
        sales_channel,
        pre_sales_manager,
        agreement_url,
        agreement_number
      } = this.form

      return {
        /* eslint-disable camelcase */
        project_manager_id: project_manager ? project_manager.id : undefined,
        account_manager_id: account_manager ? account_manager.id : undefined,
        business_developer_id: business_developer ? business_developer.id : undefined,
        pre_sales_manager_id: pre_sales_manager ? pre_sales_manager.id : null,
        sales_channel_id: sales_channel ? sales_channel.id : null,
        is_custom_project: Number(is_custom_project),
        key: is_custom_project ? custom_project_key : project.key,
        name: is_custom_project ? custom_project_name : project.name,
        task_for_logging_time: is_custom_project ? custom_project_task_for_logging_time.split(',') : project.task_for_logging_time,
        color: color.hex,
        priority: priority.id,
        budget_risks: budget_risks,
        status: status ? status.toLowerCase() : '',
        project_type,
        agreement_url,
        agreement_number
      }
    },
    submit () {
      if (this.isEdit) {
        this.editProject()
      } else {
        this.createProject()
      }
    },
    createProject () {
      this.isDataPageLoading = true

      this.$api.projects.create({ ...this.prepareFormDataForRequest() }
      )
        .then(result => {
          this.$snotify.success(
            'Project successfully created',
            'Success',
            this.$store.state.snotify
          )
          this.reloadProjects()
          this.hideModal()
        })
        .catch(err => {
          console.log(err)
          if (err.response) {
            var errors = Object.values(err.response.data.errors)

            for (var i = 0; i < errors.length; i++) {
              if (errors[i][0]) {
                this.$snotify.error(
                  errors[i][0],
                  'Error',
                  this.$store.state.snotify
                )
              }
            }
          }
        }).finally(() => {
          this.isDataPageLoading = false
        })
    },
    editProject () {
      this.isDataPageLoading = true
      this.$api.projects.update(this.form.id, { ...this.prepareFormDataForRequest() })
        .then(result => {
          this.$snotify.success(
            'Project successfully saved',
            'Success',
            this.$store.state.snotify
          )
          this.reloadProjects()
          this.hideModal()
        })
        .catch(err => {
          console.log(err)
          if (err.response) {
            var errors = Object.values(err.response.data.errors)

            for (var i = 0; i < errors.length; i++) {
              if (errors[i][0]) {
                this.$snotify.error(
                  errors[i][0],
                  'Error',
                  this.$store.state.snotify
                )
              }
            }
          }
        }).finally(() => {
          this.isDataPageLoading = false
        })
    },
    onReset () {
      this.form = { ...this.formDefault, color: { ...this.formDefault.color } }
      /* Trick to reset/clear native browser form validation state */
      this.$nextTick(() => {
        this.show = true
      })
    },
    fetchProjects () {
      return this.$api.projects.getProjects()
    },
    reloadProjects () {
      this.fetchProjects().then(() => {
        this.filterProject(this.$refs.filters.selectedFilters)
      })
    },
    async remove (item) {
      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete the project?'
      )
      if (!confirm) return

      this.isDataPageLoading = true
      this.$api.projects.remove(
        item.id
      )
        .then(data => {
          this.reloadProjects()
          this.$snotify.success(
            'Project successfully removed',
            'Success',
            this.$store.state.snotify
          )
        })
        .catch(err => {
          console.log(err)
          var errors = Object.values(err.response.data.errors)
          for (var i = 0; i < errors.length; i++) {
            this.$snotify.error(
              errors[i][0],
              err.response.data.message ?? 'Error',
              Object.assign({}, this.$store.state.snotify, { timeout: 7000 })
            )
          }
        }).finally(() => {
          this.isDataPageLoading = false
        })
    },
    findPriorityById (id = 2, returnObject) {
      const priority = this.priorities.find(priority => priority.id === id)
      if (returnObject) {
        return priority
      }
      return priority.name
    },
    findProjectBId (id, returnObject) {
      const project = this.projects.find(priority => priority.id === id)
      if (returnObject) {
        return project
      }
      return project.name
    },
    getProjectDashboardKey (item) {
      return item.is_custom_project ? 'OUT' : item.key
    }
  }
}
</script>

<style lang="scss">

  .project-status{
    font-style: italic;
    &.development{
      color: #3D5170;
    }
    &.done{
      color: #3FA52F;
    }
    &.predevelopment{
      color: #DC3545;
    }
  }
.project-select{
  .vs__dropdown-toggle{
    height: 38px;
  }
  .vs__actions{
    height: 38px;
    padding: 0 5px;
  }
  .vs__selected-options{
    height: 38px;
  }
  .vs__selected{
    margin: 0;
  }
  &.vs--single.vs--open .vs__selected{
    opacity: 0;
  }
  &.v-select .vs__actions{
    padding: 0 5px;
  }
}
.project-color {
  width: 24px;
  height: 24px;
  span {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 3px;
  }
}
.block-loader {
  height: 85px;
}
.color-picker {
  width: 100% !important;
}
.vs__dropdown-menu, .vs__selected{
  text-transform: capitalize;
}
</style>
